import {DateTime} from 'luxon';

export const NEXT_DAY_HOUR = 19;

export class Doctor {
  name: string = '';
  email: string = '';
  image: string = '';
  isAccountable: boolean = false;
  type: 'Gyógytornász' | 'Masszőr' | 'Dietetikus' = 'Gyógytornász';
  reservationInfo: {
    start: string;
    interval: number;
    breakTime: number;
  } = {
    start: '',
    interval: 0,
    breakTime: 0,
  }
}

export const AvailableDoctors: Doctor[] = [
  {
    name: 'Enesei Rita', email: 'perlaritta@gmail.com', image: 'rita.webp', type: 'Gyógytornász', reservationInfo: {
      start: '8:00',
      interval: 60,
      breakTime: 0,
    },
    isAccountable: true
  },
  {
    name: 'Kaufer Barbara', email: 'kaufer.barbara@gmail.com', image: 'barbi.webp', type: 'Masszőr', reservationInfo: {
      start: '7:00',
      interval: 30,
      breakTime: 30,
    },
    isAccountable: false
  },
  {
    name: 'Meleghegyi Fanni',
    email: 'm.fanni94@gmail.com',
    image: 'fanni.webp',
    type: 'Gyógytornász',
    reservationInfo: {
      start: '8:30',
      interval: 30,
      breakTime: 0,
    },
    isAccountable: false
  },
  {
    name: 'Szépe Flóra',
    email: 'szepeflora14@gmail.com',
    image: 'flora.webp',
    type: 'Gyógytornász',
    reservationInfo: {
      start: '8:00',
      interval: 60,
      breakTime: 0,
    },
    isAccountable: false
  },
  {
    name: 'Szokol Leticia Réka',
    email: 'kicsiletti01@gmail.com',
    image: 'letti.jpeg',
    type: 'Masszőr',
    reservationInfo: {
      start: '08:00',
      interval: 30,
      breakTime: 0,
    },
    isAccountable: false
  },
  {
    name: 'Fülöp Kinga',
    email: 'egyensulyszerviz@gmail.com',
    image: 'kinga.jpg',
    type: 'Masszőr',
    reservationInfo: {
      start: '08:00',
      interval: 30,
      breakTime: 0,
    },
    isAccountable: false
  },
  {
    name: 'Fülöp Kinga',
    email: 'egyensulyszerviz@gmail.com',
    image: 'kinga.jpg',
    type: 'Dietetikus',
    reservationInfo: {
      start: '08:00',
      interval: 60,
      breakTime: 0,
    },
    isAccountable: false
  },
  {
    name: 'Enesei Lilla', email: 'enesei.lilla@gmail.com', image: 'rita.webp', type: 'Gyógytornász', reservationInfo: {
      start: '8:00',
      interval: 30,
      breakTime: 30,
    },
    isAccountable: true
  },
  {
    name: 'EREF fizioterapia', email: 'fizioeref@gmail.com', image: 'rita.webp', type: 'Gyógytornász', reservationInfo: {
      start: '8:00',
      interval: 60,
      breakTime: 0,
    },
    isAccountable: false
  },
]

export type ProblemCategory = 'massage' | 'physiotherapy' | 'other';

export class Problem {
  name: string = '';
  doctor: Doctor[] = [];
  icon: string = '';
  duration: number = 0;
  category: 'massage' | 'physiotherapy' | 'dietetics' | 'other' = 'physiotherapy';
}

export const ProblemList: Problem[] = [
  {
    name: 'Gerincfájdalom (derék, hát, nyak), végtagokba kisugárzó fájdalmak, McKenzie terápia',
    doctor: [AvailableDoctors[3], AvailableDoctors[0]],
    icon: 'spine.png',
    duration: 60,
    category: 'physiotherapy',
  },
  {
    name: 'Mozgásszervi megbetegedések, ízületi bántalmak, tartáshibák',
    doctor: [AvailableDoctors[3], AvailableDoctors[0]],
    icon: 'leg.png',
    duration: 60,
    category: 'physiotherapy',
  },
  {
    name: 'Sportsérülés',
    doctor: [AvailableDoctors[3], AvailableDoctors[0]],
    icon: 'sport.png',
    duration: 60,
    category: 'physiotherapy',
  },
  {
    name: 'Műtétek utáni fizioterápia',
    doctor: [AvailableDoctors[3], AvailableDoctors[0]],
    icon: 'hospital.png',
    duration: 60,
    category: 'physiotherapy',
  },
  {
    name: 'Neurológiai kórképek (Stroke, Parkinson-kór, Sclerosis multiplex stb.)',
    doctor: [ AvailableDoctors[0]],
    icon: 'brain.png',
    duration: 60,
    category: 'physiotherapy',
  },
  {
    name: 'Belgyógyászati betegségek (szívbetegség, légzőszervi megbetegedés, poszt-covid)',
    doctor: [AvailableDoctors[3]],
    icon: 'heart.png',
    duration: 60,
    category: 'physiotherapy',
  },
  {
    name: 'Masszázs (60 perc)',
    doctor: [AvailableDoctors[5], AvailableDoctors[4]],
    icon: 'body-massage.png',
    duration: 60,
    category: 'massage',
  },
  {
    name: 'Masszázs (30 perc)',
    doctor: [AvailableDoctors[5], AvailableDoctors[4]],
    icon: 'massage-30.png',
    duration: 30,
    category: 'massage',
  },
  {
    name: 'Gerincjóga',
    doctor: [],
    icon: 'yoga.png',
    duration: 60,
    category: 'other',
  },
  {
    name: 'Dietetika - első konzultáció',
    doctor: [AvailableDoctors[6]],
    icon: 'dietitian.png',
    duration: 90,
    category: 'dietetics',
  },
  {
    name: 'Dietetika - kontroll',
    doctor: [AvailableDoctors[6]],
    icon: 'dietitian-controll.png',
    duration: 40,
    category: 'dietetics',
  },
  {
    name: 'Egyéb',
    doctor: [AvailableDoctors[3], AvailableDoctors[0]],
    icon: 'other.png',
    duration: 60,
    category: 'physiotherapy',
  }
];

export class Patient {
  name: string = '';
  email: string = '';
  phoneNumber: string = '';
}

export class PendingEvent {
  startTime: string = '';
  endTime: string = '';
  doctor: Doctor = {} as Doctor;
  problem: Problem = {} as Problem;
  patient: Patient = {} as Patient;
  other: string = '';

  constructor(time: DateTime | undefined, problem: Problem, doctor: Doctor, patient: Patient, other: string) {
    this.startTime = time?.toISO() || '';
    this.endTime = time?.plus({minute: problem.duration}).toISO() || '';
    this.doctor = doctor;
    this.problem = problem;
    this.patient = patient;
    this.other = other;
  }
}
